import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { handleError } from "../../utils/helper";
import { useAppKitAccount } from "@reown/appkit/react";
import { usePublicClient, useWriteContract } from "wagmi";
import { DAO_ABI } from "../../Contract/DAO_ABI";
import { DAO_CONTRACT_ADDRESS } from "../../utils/constant";
import { config } from "../../config";
import { readContract } from "@wagmi/core";
import { useAuth } from "../../context/AuthContext";

const SetTotalVotersCountModal = ({ show, handleClose }) => {
  const { icoValues, fetchIcoValues } = useAuth();
  const [totalVoters, setTotalVoters] = useState(
    icoValues?.totalVotersCount || ""
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const { address } = useAppKitAccount();
  const publicClient = usePublicClient();
  const { writeContractAsync } = useWriteContract();

  const validate = () => {
    const newErrors = {};

    if (!totalVoters) {
      newErrors.totalVoters = "Total voters count is required";
    } else if (isNaN(Number(totalVoters))) {
      newErrors.totalVoters = "Must be a number";
    } else if (Number(totalVoters) <= 0) {
      newErrors.totalVoters = "Must be greater than 0";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSetTotalVoters = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const contractData = {
        abi: DAO_ABI,
        address: DAO_CONTRACT_ADDRESS,
        functionName: "setTotalVotersCount",
        args: [Number(totalVoters)],
      };

      await readContract(config, { ...contractData, account: address });
      const tx = await writeContractAsync(contractData);
      const receipt = await publicClient.waitForTransactionReceipt({
        hash: tx,
      });

      if (receipt?.status === "success") {
        toast.success("Total Voters Count updated successfully");
        await fetchIcoValues();
        handleClose();
      }
    } catch (error) {
      const err = handleError(error?.cause?.data);
      toast.error(err || "Transaction failed");
      console.error("setTotalVotersCount error:", err);
    } finally {
      setLoading(false);
      setErrors({});
    }
  };

  return (
    <>
      {loading && <Loader />}

      <Modal
        show={show}
        onHide={() => {
          handleClose();
          setErrors({});
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Set Total Voters Count</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Total Voters Count</Form.Label>
              <Form.Control
                type="number"
                value={totalVoters}
                placeholder="Enter total voters count"
                onChange={(e) => setTotalVoters(e.target.value)}
                className={`${errors.totalVoters ? "is-invalid" : ""}`}
              />
              {errors.totalVoters && (
                <div className="invalid-feedback">{errors.totalVoters}</div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose();
              setErrors({});
            }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSetTotalVoters}>
            Set Count
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SetTotalVotersCountModal;
